import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

import { FriendlyDateTime } from '../Date/friendly-date-time'
import { Toast } from '../NarusMaterial'

interface FileToastProps {
  id: string
  clientName: string
  patientId: string
  createdAt: string
  patientName: string
  close: (id: string) => void
}

export function FileToast ({ id, clientName, patientId, createdAt, patientName, close }: FileToastProps): JSX.Element {
  const navigate = useNavigate()

  const handleClose = useCallback((): void => {
    close(id)
  }, [ close, id ])

  function handleCardClick (): void {
    navigate(`/patient/${clientName}/${patientId}/patientFolder`)
  }

  return (
    <Toast onDelete={handleClose}>
      <Content
        onClick={handleCardClick}
        createdAt={createdAt}
        patientName={patientName}
      />
    </Toast>
  )
}

interface ContentProps {
  createdAt: string
  patientName: string
  onClick: () => void
}

function Content ({ createdAt, patientName, onClick }: ContentProps): JSX.Element {
  return (
    <button
      className='cursor-pointer'
      onClick={onClick}
    >
      <h2>New File</h2>
      <p>New file uploaded by {patientName}</p>
      <p className='time'>
        <FriendlyDateTime datetime={createdAt} />
      </p>
    </button>
  )
}
